import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { SupportActivityTrackerService } from './support-activity-tracker.service';

/**
 * Logs every API call (method, final URL, redacted payload, status, timing)
 * into the support activity buffer. Registered last in the chain so it sees
 * the URL after base/params interceptors and the raw backend response.
 */
export const SupportActivityInterceptor: HttpInterceptorFn = (req, next) => {
  const tracker = inject(SupportActivityTrackerService);
  const id = tracker.beginRequest(req.method, req.urlWithParams, req.body);
  if (id === null) return next(req);

  let settled = false;
  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          settled = true;
          tracker.completeRequest(id, event.status, event.statusText);
        }
      },
      error: (err: unknown) => {
        settled = true;
        if (err instanceof HttpErrorResponse) {
          tracker.completeRequest(id, err.status, err.statusText, err.error);
        } else {
          tracker.completeRequest(id, 0, String(err));
        }
      },
    }),
    finalize(() => {
      if (!settled) tracker.cancelRequest(id);
    }),
  );
};
